module.exports = __webpack_public_path__ + "img/index-bg2.55fedb42.png";